// extracted by mini-css-extract-plugin
export default {"error":"TurnstileWidget-module_error_ec469c"};